import { Avatar, Grid, Typography } from "@mui/material";

import { styled } from "@mui/system";
import {
  avatarAtom,
  publisherNameAtom,
  userFullNameAtom,
  userRoleDisplayDescriptionAtom,
} from "../../../../atom/atoms";
import { useAtom } from "jotai";

const StyledGridItemInfoContainer = styled(Grid)`
  &.MuiGrid-item {
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 0.375rem;
  }
`;

// UserDetailsArea is a component that is purerly consisted of atoms
// when the atom values that the component holds changed anywhere in the application
// component updates aswell
const UserDetailsArea = (props) => {
  const [avatar] = useAtom(avatarAtom);
  const [publisherName] = useAtom(publisherNameAtom);
  const [userRole] = useAtom(userRoleDisplayDescriptionAtom);
  const [userFullName] = useAtom(userFullNameAtom);

  return (
    <>
      <Avatar src={avatar} sx={{ width: 60, height: 60 }} />
      <StyledGridItemInfoContainer flexDirection={"colummn"} item xs={12}>
        <Typography fontSize={12} variant="body">
          {userFullName}
        </Typography>
        <Typography fontSize={12} color="primary">
          {publisherName ? publisherName : "-"}
        </Typography>
        <Typography fontSize={10} variant="body1">
          {userRole}
        </Typography>
      </StyledGridItemInfoContainer>
    </>
  );
};

export default UserDetailsArea;
